var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useEffect, useMemo, useState, } from "react";
import { typeSafeObjectEntries, typeSafeObjectFromEntries, } from "../../../utils/helpers";
import { sortMethods, sortOptions, } from "../../../utils/sorting";
import { isValidOverlayKey, } from "../components/overlay/Overlay";
var settings = {
    disableChatPopup: {
        title: "Prevent mod-triggered card pop-ups",
        type: "boolean",
        process: function (value) { return !!value; },
        configurable: true,
    },
    disableCardEffects: {
        title: "Disable 3D card effects",
        type: "boolean",
        process: function (value) {
            return !!(value !== null && value !== void 0 ? value : window.matchMedia("(prefers-reduced-motion: reduce)").matches);
        },
        configurable: true,
    },
    ambassadorSort: {
        title: "Sort cards by",
        type: "select",
        options: sortOptions,
        process: function (value) {
            return sortMethods.includes(value) ? value : "default";
        },
        configurable: true,
    },
    disableOverlayHiding: {
        title: "(DEV) Prevent app hiding automatically",
        type: "boolean",
        process: function (value) { return !!value; },
        configurable: process.env.NODE_ENV === "development",
    },
    openedMenu: {
        title: "Menu that was last opened",
        type: "string",
        process: function (value) {
            return isValidOverlayKey(value) ? value : "ambassadors";
        },
        configurable: false,
    },
};
var Context = createContext(undefined);
export var SettingsProvider = function (_a) {
    var children = _a.children;
    var _b = useState(function () {
        // Load settings from local storage on mount, merging with defaults
        var storage = JSON.parse(localStorage.getItem("settings") || "{}");
        return typeSafeObjectEntries(settings).reduce(function (acc, _a) {
            var _b;
            var key = _a[0], value = _a[1];
            return (__assign(__assign({}, acc), (_b = {}, _b[key] = value.process(storage[key]), _b)));
        }, {});
    }), stored = _b[0], setStored = _b[1];
    // Save settings to local storage when they change
    useEffect(function () {
        localStorage.setItem("settings", JSON.stringify(stored));
    }, [stored]);
    // Change the value of a setting
    var change = useCallback(function (key, value) {
        setStored(function (current) {
            var _a;
            return (__assign(__assign({}, current), (_a = {}, _a[key] = value, _a)));
        });
    }, []);
    // Expose a full object for the settings
    var obj = useMemo(function () {
        return typeSafeObjectFromEntries(typeSafeObjectEntries(settings).map(function (_a) {
            var key = _a[0], value = _a[1];
            return [
                key,
                __assign(__assign({}, value), { value: stored[key], change: function (value) { return change(key, value); } }),
            ];
        }));
    }, [stored, change]);
    return _jsx(Context, { value: obj, children: children });
};
var useSettings = function () {
    var ctx = useContext(Context);
    if (!ctx)
        throw new Error("useSettings must be used within a SettingsProvider");
    return ctx;
};
export default useSettings;
